import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography } from '@material-ui/core';
import TabPanel from '../TabPanel';
import TabContainer from './styles';
import SwipeableViews from 'react-swipeable-views';

const tabId = 'full-width-tab';
const tabPanelAria = 'full-width-tabpanel';

const a11yProps = index => {
	return {
		id: `${tabId}-${index}`,
		'aria-controls': `${tabPanelAria}-${index}`
	};
};

const DefaultTabs = props => {
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const getTabList = () => {
		return props.items.map((tab, idx) => (
			<Tab
				label={<Typography className={'tabLabel'}>{tab.label}</Typography>}
				{...a11yProps(idx)}
				className={'tab'}
			/>
		));
	};

	const getTabPanel = () => {
		return props.items.map((tab, idx) => (
			<TabPanel value={value} index={idx} tabId={tabId} tabPanelAria={tabPanelAria}>
				{tab.component}
			</TabPanel>
		));
	};

	const getDots = () => {
		return props.items.map((tab, idx) => (
			<div
				className={`dot ${idx === value ? 'dot-selected' : ''}`}
				key={idx}
				onClick={() => setValue(idx)}
			/>
		));
	};

	return (
		<TabContainer {...props}>
			<Tabs
				value={value}
				onChange={handleChange}
				indicatorColor="primary"
				textColor="primary"
				centered
				className="tabs-container"
			>
				{getTabList()}
			</Tabs>
			<SwipeableViews
				axis={'x'}
				index={value}
				onChangeIndex={newValue => setValue(newValue)}
			>
				{getTabPanel()}
			</SwipeableViews>
			<div className="dot-container">{getDots()}</div>
		</TabContainer>
	);
};

export default DefaultTabs;

DefaultTabs.defaultProps = {
	items: [],
	showTitleTab: true
};

DefaultTabs.propTypes = {
	items: PropTypes.node.isRequired,
	showTitleTab: PropTypes.bool
};
